import React, { Component, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

function AddToProjectModal(props) {

  const [project, setProject] = useState('')
  const onProjectChange = (event) => { setProject(event.target.value) }

  const handleSubmit = (event) => {
     event.preventDefault();
     props.onOK(project.substring(1), project.substring(0,1))
  }

  return (
    <Modal show={props.show} onHide={props.onClose}  animation={false} backdrop="static">
      <Form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>Add to project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Project</Form.Label>
            <Form.Control as="select" onChange={onProjectChange} value={project} required>
                <option disabled hidden value=''></option>
                <option disabled value='@'> --- My projects --- </option>
                {props.myProjects.map((project, index) =>
                  <option key={index} value={'m' + project.id}>{project.name}</option>
                )}
                <option disabled value='@'> --- Public projects --- </option>
                {props.joinedProjects.map((project, index) =>
                  <option key={index} value={'p' + project.id}>{project.name}</option>
                )}
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" variant="primary">
            OK
          </Button>
          <Button variant="secondary" onClick={props.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default AddToProjectModal;
